import { SVC_B } from './base.js'

export function addNewDomainAndCameras (newDomain) {
  return SVC_B.post(`/api/v1/domain/new`, newDomain)
}
